import {useRef, useEffect} from "react";

export const TableRowProps = {
    className: "material-ui-table-body-row",
};

export const TableCellClass = {
    className: "material-ui-table-body-cell",
    scope: "row"
};

export const initialState = {
    isHubServerEnabled: false,
    editMode: false,
    isFormError: false,
    hubMode: "2",
    portNumber: "",
    primaryHubURI: "",
    failoverHubURI: "",
    certGenType: true,
    rootCertificateRequest: "",
    issuerCertFile: "",
    issuerCertificate: "",
    issuerCertificateValidity: "",
    issuerCertValidityYear: "",
    hubCertValidity: "",
    operationalCertificateRequest: "",
    oprCertValidityYear: "",
    tlsVersion: "Tls13",
    isModelOpen: false,
    selectedCertificate: null,
    selectedFileKey: null
 }

export const formErrorMessages = {
    portNumber: "Invalid port number",
    primaryHubURI: "Invalid URL",
    failoverHubURI: "Invalid URL",
    rootCertificateRequest: "No certificate imported",
    issuerCertFile: "Invalid file",
    issuerCertificate: "Invalid name",
    issuerCertValidityYear: "Invalid number",
    oprCertValidityYear: "Invalid number",
    operationalCertificateRequest: "No certificate imported",
    InvalidFile: "Only .pem extension files are allowed"
};

export const commonFields = ["hubMode", "portNumber", "primaryHubURI", "failoverHubURI", "tlsVersion"];

export const hubAndCAMode = ["issuerCertificate", "issuerCertValidityYear", "oprCertValidityYear"];

export const hubMode = ["rootCertificateRequest", "operationalCertificateRequest"];

export const commonErrorFields = ["portNumber", "primaryHubURI"];

export const numberFields = ["portNumber", "issuerCertValidityYear", "oprCertValidityYear"];

export const fileInputFields = ["rootCertificateRequest", "operationalCertificateRequest"];

export const isEmpty = (data) => {
    if (Array.isArray(data)) {
        return data.length ? true : false;
    } else {
        return Object.keys(data).length ? false : true;
    }
}


// const payloadKeyMap = {
//     rootCertificate: "rootCertificateRequest",
//     issuerCertificate : "issuerCertFile",
//     operationalCertificate: "operationalCertificateRequest"
// };

export const getFormDataPayload = (data = {}, fieldKeys = []) => {
    const payload = new FormData();
    fieldKeys.map(fieldKey => {
        // for file handling
        if (hubMode.includes(fieldKey)) {
            data[fieldKey] && data[fieldKey].length ? payload.append([fieldKey], data[fieldKey][0]) : payload.append([fieldKey], null);
        } else {
            payload.append([fieldKey], data[fieldKey]);
        }
        return fieldKey;
    });
    return payload;
}

const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptop: '1024px',
    laptopM: '1374px',
    laptopL: '1440px',
    desktop: '2560px'
}

export const device = {
    mobileS: `(max-width: ${size.mobileS})`,
    mobileM: `(max-width: ${size.mobileM})`,
    mobileL: `(max-width: ${size.mobileL})`,
    tablet: `(max-width: ${size.tablet})`,
    laptop: `(max-width: ${size.laptop})`,
    laptopM: `(max-width: ${size.laptopL})`,
    laptopL: `(max-width: ${size.laptopL})`,
    desktop: `(max-width: ${size.desktop})`,
    desktopL: `(max-width: ${size.desktop})`
  };

  export const timeZoneAbbreviated = (datestring) => {
    const { 1: tz } = new Date(datestring).toString().match(/\((.+)\)/);
    if (tz.includes(" ")) {
      return tz
        .split(" ")
        .map(([first]) => first)
        .join("");
    } else {
      return tz;
    }
  };

  export const userAccessPermission = {
     None                     : 0,
     View                     : 1,
     Edit                     : 2,
     Override                 : 3,
     ResetPassword            : 4,
     Full                     : 5,
     Create                   : 20,
     Delete                   : 21,
     CreateOrDelete           : 22,
     Acknowledge              : 23,
     InsertComments           : 24,
     EditAlarmRouting         : 25,
     ConfigureAlarmRecipients : 26,
     ApplyOrCancelExceptions  : 27,
     CreateOrEditExceptions   : 28,
     ApplyOrCancelSnowDay     : 29,
     AdvancedOverrides        : 30,
     IgnoreAlarms             : 31,
     CriticalPoint            : 34,
};


export const hubServerErrors = {
    ERRCE0000: "Okay",
    ERRCE0001: "Certificate was expired",
    ERRCE0002: "Certificate was not signed by trusted CA authority",
    ERRCE0003: "Certificate was not well formed or format not supported",
    ERRCE0004: "Error while building certificate chain",
    ERRCE0005: "Certificate was removed",
    ERRCE0006: "Private key does not match with certificate public key",
    ERRCE0007: "Certificate is not a CA authority",
    ERRCE0008: "Internal server error",
    ERRCE0009: "Unknown",
    ERRHE0000: "Okay",
    ERRHE0001: "Port number is already used by another process",
    ERRHE0002: "Port number is not matching with the configured value",
    ERRHE0003: "Internal server error",
    ERRHE0004: "Unknown",
    ERRHE0005: "Invalid Argument"
}

export const useInterval = (callback, delay) => {
    const savedCallback = useRef();
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    useEffect(() => {
        function tick() {
          savedCallback.current();
        }
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
    }, [delay]);
}

export const replaceString = (stringValue, start, end, replaceWith) => {
    if (stringValue && stringValue.length) {
        return stringValue.substring(0, start) + replaceWith + stringValue.substring(end);
    } else {
        return "";
    }
}